import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';

export default function QualityAssurance() {
  const { qualityAssurance = {} } = useContent();
  const {
    image, tag, title, paragraphs = [],
    process = [], parameters = [], commitments = [],
  } = qualityAssurance;

  return (
    <>
      <PageHero title="Quality Assurance" image={image} />

      {/* Intro — 50/50 image + copy */}
      <section>
        <div className="container profile-grid">
          <div className="profile-image">
            <img src={image} alt={title} />
          </div>
          <div className="profile-content">
            {tag ? <span className="section-tag">{tag}</span> : null}
            <h2>{title}</h2>
            {paragraphs.map((p) => <p key={p}>{p}</p>)}
          </div>
        </div>
      </section>

      {/* Quality control process — 3-up white cards on the grey band */}
      {process.length ? (
        <section className="grey-bg">
          <div className="container">
            <SectionHead title="Our Quality Control Process" />
            <div className="facility-grid">
              {process.map((p) => (
                <div className="facility-card" key={p.title}>
                  <i className={`fas ${p.icon}`} />
                  <h3>{p.title}</h3>
                  <p>{p.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      {/* Quality parameters — 5-up maroon tiles */}
      {parameters.length ? (
        <section>
          <div className="container">
            <SectionHead title="Quality Parameters" />
            <div className="parameter-grid">
              {parameters.map((p) => (
                <div className="parameter-card" key={p.title}>
                  <i className={`fas ${p.icon}`} />
                  <h3>{p.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      {/* Quality commitment — 4-up white cards on the grey band */}
      {commitments.length ? (
        <section className="grey-bg">
          <div className="container">
            <SectionHead title="Quality Commitment" />
            <div className="certification-grid">
              {commitments.map((c) => (
                <div className="cert-card" key={c.title}>
                  <i className={`fas ${c.icon}`} />
                  <h3>{c.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
